import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-school-calendar-entry",
	templateUrl: "./calendar-entry.component.html",
	styleUrls: ["./calendar-entry.component.css"],
})
export class CalendarEntryComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////
	// Data
	///////////////////

	@Input() loadingSchools: any = false;
	@Input() loadingPrefs: any = false;
	@Input() loadingDayOps: any = false;
	@Input() loadingBellSchedule: any = false;
	@Input() loadingDayEntries: any = false;

	@Input() DayNumber: any;

	@Input() SchoolDayID: any = -1;
	@Input() lstSchoolDay: any;

	@Input() BellScheduleID: any = -1;
	@Input() lstBellSchedule: any;

	@Input() UseSchoolBellSchedule: any = false;

	@Input() CalendarDate: any;
	@Input() user: any;

	@Input() IsOpen: any = false;

	@Output() DayChange: EventEmitter<any> = new EventEmitter();

	///////////////////

	///////////////////
	// Events
	///////////////////

	onSDChange(val) {
		this.SchoolDayID = val;
		this.EmitData();
	}

	onBellChange(val) {
		this.BellScheduleID = val;
		this.EmitData();
	}

	onOpenChange(val) {
		this.IsOpen = val;
		this.EmitData();
	}

	EmitData() {
		this.DayChange.emit({
			DayID: this.SchoolDayID,
			BellScheduleID: this.BellScheduleID,
			DayNumber: this.DayNumber,
			IsOpen: this.IsOpen,
		});
	}

	///////////////////

	///////////////////
	// Helpers
	///////////////////

	EditDisable() {
		////User is SU (or district?)
		//var cond2 = this.user.personID == 0;

		//var nextDate = new Date(this.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
		//nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

		////Or Day is < today
		//var Today = new Date();
		//Today.setHours(0, 0, 0);

		//var cond3 = nextDate > Today;
		//// var cond4 = !(nextDate < Today && nextDate > Today); //Can't use == need to check not greater and not less than
		//var cond4 = nextDate.toString() == Today.toString();

		////Disable if:
		//return !(cond2 || cond3 || cond4);

		return (
			this.loadingSchools == true ||
			this.loadingPrefs == true ||
			this.loadingDayOps == true ||
			this.loadingBellSchedule == true ||
			this.loadingDayEntries == true
		);
	}

	///////////////////
}
